import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { placesElastic } from '../../constants/api';
import { PATH } from '../../envs/core';

const dataProvider = {};

/**
 * Trae el lugar con su svg y el punto de la capital de provincia
 * @param {string} ineId es el id de un lugar con el formato del INE
 * @returns
 */

export const getPlacesFromElastic = ineId => {
  if (dataProvider[ineId]) {
    return Promise.resolve(dataProvider[ineId]);
  }
  return Axios.get(`${PATH}${placesElastic}${ineId}`)
    .then(response => {
      return response.data;
    })
    .then(response => {
      dataProvider[ineId] = response;
      return response;
    });
};

export const SinglePlaceProvider = ({ id, children }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    getPlacesFromElastic(id).then(response => {
      setData(response.content);
    });
  }, [id]);

  return children(data);
};

SinglePlaceProvider.propTypes = {
  id: PropTypes.string.isRequired
};
